import http from './http'

class Provider {
  getCurrentEconomicGroup() {
    return http.get('/fornecedor/current')
  }
}

export default new Provider()
